import { CSSProperties, ReactElement, useCallback, useState } from "react";

type ExpandableComponent = {
    children: ReactElement;
    className?: string;
    style?: CSSProperties;
};

const ExpandableComponent = ({
    children,
    className = "",
    style = {},
}: ExpandableComponent) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleExpand = useCallback(() => {
        setIsExpanded(true);
    }, []);

    const handleClose = useCallback(() => {
        setIsExpanded(false);
    }, []);

    return (
        <div className={`relative ${className}`} style={style}>
            {/* Always render children in the same location */}
            <div
                className={`transition-all duration-300 ${
                    isExpanded
                        ? "fixed inset-0 z-50 flex items-center justify-center"
                        : "relative w-full h-full"
                }`}
            >
                {isExpanded && (
                    <div
                        className="absolute inset-0 bg-black opacity-50"
                        onClick={handleClose}
                    ></div>
                )}

                <div
                    className={`${
                        isExpanded
                            ? "relative bg-white rounded-lg shadow-xl w-11/12 max-w-5xl max-h-screen overflow-auto p-4"
                            : "w-full h-full"
                    }`}
                >
                    {children}

                    {isExpanded ? (
                        <button
                            className="btn btn-sm btn-circle absolute right-2 top-2"
                            onClick={handleClose}
                        >
                            ✕
                        </button>
                    ) : (
                        <button
                            className="btn btn-sm btn-circle absolute top-2 right-2 bg-base-100 hover:bg-base-200 z-10"
                            onClick={handleExpand}
                            title="Expand"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"
                                />
                            </svg>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export { ExpandableComponent };
